import {FC} from 'react'
import {Modal, ModalProps} from 'react-bootstrap'

interface CustomeModalProps extends ModalProps {
  title: string
  children: React.ReactNode
  size?: ModalProps['size']
}

export const CustomModal: FC<CustomeModalProps> = ({title, size, children, ...props}) => {
  return (
    <Modal size={size} backdrop='static' keyboard={false} scrollable {...props}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  )
}

CustomModal.defaultProps = {
  size: 'xl',
}
